import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bmf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Normalize FastAPI 422 validation errors (array of objects) into a friendly string
    // so consumers can safely use err.response.data.detail as a message.
    const detail = err?.response?.data?.detail;
    if (Array.isArray(detail)) {
      const msg = detail
        .map((d) => {
          if (typeof d === "string") return d;
          const field = Array.isArray(d?.loc) ? d.loc.filter((x) => x !== "body").join(".") : "";
          return field ? `${field}: ${d.msg}` : d.msg;
        })
        .filter(Boolean)
        .join(", ");
      err.response.data.detail = msg || "Validation failed";
    } else if (detail && typeof detail === "object") {
      err.response.data.detail_obj = detail;
      err.response.data.detail = detail.msg || detail.message || JSON.stringify(detail);
    }
    if (err?.response?.status === 401) {
      // Skip auto-logout for auth endpoints so the caller can display an
      // inline error (e.g. wrong current password on the force-change screen).
      const url = err?.config?.url || "";
      const isAuthEndpoint = /\/auth\/(login|change-password)/.test(url);
      if (!isAuthEndpoint) {
        localStorage.removeItem("bmf_token");
        localStorage.removeItem("bmf_user");
        if (!window.location.pathname.startsWith("/login")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
